import { Box, Card, Switch, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SingleSelectField from "@saleor/components/SingleSelectField";
import React from "react";

const useStyles = makeStyles(
  _ => ({
    container: {
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
      flex: 1,
      minWidth: "300px"
    },
    containerBottom: {
      padding: "20px"
    },
    containerTop: {
      borderBottom: "solid #CED3DD 1px",
      padding: "20px"
    },
    disabledChecked: {
      "&.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: "#a5b7ff !important"
      }
    },
    header: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "16px"
    },
    input: {
      flex: 1,
      minWidth: "100px"
    },
    inputContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "12px"
    },
    switchBase: {
      "&.Mui-checked": {
        color: "#0030FF !important"
      },
      "&.Mui-disabled": {
        color: "#F1F2F3 !important"
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: "#F1F2F3 !important"
      }
    },
    switchChecked: {
      color: "#0030FF !important"
    },
    switchRoot: {
      "&.Mui-checked": {
        color: "#0030FF !important"
      },
      "&.Mui-disabled": {
        color: "#F1F2F3 !important"
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: "#F1F2F3 !important"
      }
    },
    switchThumb: {
      backgroundColor: "#fff !important",
      borderRadius: "50%",
      height: "20px !important",
      width: "20px !important"
    },
    switchTrack: {
      ".Mui-checked + &": {
        backgroundColor: "#0030FF !important"
      },
      backgroundColor: "#F1F2F3 !important"
    },
    title: {
      color: "#0030FF",
      fontSize: "18px",
      fontWeight: "bold"
    }
  }),
  {
    name: "ExpressFleetOpsFormCard"
  }
);

export interface ExpressFleetOpsFormCardProps {
  formTitle: string;
  switchEnabled: boolean;
  switchOnChange: () => void;
  disabled: boolean;
  selectedCourier: string;
  selectedCourierOnChange: (event: any) => any;
  courierChoices: any;
  readyStatusMinutes: number | null;
  collectedStatusMinutes: number | null;
  anyStatusMinutes: number | null;
  readyStatusMinutesOnChange: (event: any) => void;
  collectedStatusMinutesOnChange: (event: any) => void;
  anyStatusMinutesOnChange: (event: any) => void;
}

const ExpressFleetOpsFormCard: React.FC<ExpressFleetOpsFormCardProps> = props => {
  const {
    formTitle,
    switchEnabled,
    switchOnChange,
    disabled,
    selectedCourier,
    selectedCourierOnChange,
    courierChoices,
    readyStatusMinutes,
    collectedStatusMinutes,
    anyStatusMinutes,
    readyStatusMinutesOnChange,
    collectedStatusMinutesOnChange,
    anyStatusMinutesOnChange
  } = props;

  const classes = useStyles({});

  return (
    <Card className={classes.container}>
      <Box className={classes.containerTop}>
        <Box className={classes.header}>
          <Typography className={classes.title}>{formTitle}</Typography>
          <Box display="flex" alignItems="center">
            <Typography>Accept Auto Booking</Typography>
            <Switch
              id="expressFleetOpsFormCardSwitch"
              checked={switchEnabled}
              onChange={switchOnChange}
              color="primary"
              disabled={disabled}
              classes={{
                checked: classes.switchChecked,
                root:
                  switchEnabled && disabled
                    ? classes.disabledChecked
                    : classes.switchRoot,
                switchBase:
                  switchEnabled && disabled
                    ? classes.disabledChecked
                    : classes.switchBase,
                thumb: classes.switchThumb,
                track: classes.switchTrack
              }}
            />
          </Box>
        </Box>

        <SingleSelectField
          key="expressFleetOpsFormCardCourier"
          value={selectedCourier}
          onChange={selectedCourierOnChange}
          disabled={disabled}
          choices={courierChoices}
          label="Assigned Courier"
          placeholder="Assigned Courier"
        />
      </Box>

      <Box className={`${classes.containerBottom} ${classes.inputContainer}`}>
        <TextField
          id="expressFleetOpsFormCardReadyTxt"
          className={classes.input}
          disabled={disabled}
          label="Ready Status (mins) *"
          type="number"
          value={readyStatusMinutes || ""}
          onChange={readyStatusMinutesOnChange}
        />
        <TextField
          id="expressFleetOpsFormCardCollectedTxt"
          className={classes.input}
          disabled={disabled}
          label="Collected Status (mins) *"
          type="number"
          value={collectedStatusMinutes || ""}
          onChange={collectedStatusMinutesOnChange}
        />
        <TextField
          id="expressFleetOpsFormCardAnyTxt"
          className={classes.input}
          disabled={disabled}
          label="Any Status (mins) *"
          type="number"
          value={anyStatusMinutes || ""}
          onChange={anyStatusMinutesOnChange}
        />
      </Box>
    </Card>
  );
};
export default ExpressFleetOpsFormCard;
